import _root_default from "./_root.js";
import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_Map.js
var Map = _getNative_default(_root_default, "Map");
var _Map_default = Map;

//#endregion
export { _Map_default as default };
//# sourceMappingURL=_Map.js.map